import { GridColDef } from '@mui/x-data-grid';
import {
    Box,
    TextField,
    Button,
    Alert,
    InputAdornment,
    IconButton,
    Typography,
} from '@mui/material';
import { atom, useSetAtom } from 'jotai';
import AddIcon from '@mui/icons-material/Add';
import { COLORS } from '../../../theme/themeConstants';
import { useCallback, useState, useMemo } from 'react';
import EditStoreOwnerModal from '../EditStoreOwnerModal';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import CommonDataGrid from '../../Stateless/CommonDataGrid';
import { usePermissions } from '../../../context/PermissionContext';
import AddNewsLetter from './AddNewsLetter';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PermissionActionButtons from '../../Stateless/Common/PermissionActionButtons';
import { useSnackbar } from '../../Stateless/SnackBarProvider';
import { useGetNewsletterSubscribers, useDeleteNewsletterSubscribers, useToggleNewsletterSubscribersStatus } from '../../Query/NewsletterQuery';
// import { useDebounce } from '../../HelperFunctions/Hooks/useQueryParams';

export interface CMSDataType {
    id?: any;
    pageTitle?: string;
    pageTitleInArabic?: string;
    pageDescription?: string;
    pageDescriptionInArabic: string;
}

export const CMSAtom = atom<CMSDataType | null>(null);

// type StoreWithSno = {
//     id: string;
//     sno: number;
//     pageTitle: string;
// };


const NewsLetter = () => {
    const { showMessage } = useSnackbar();
    const setCMSAtom = useSetAtom(CMSAtom);
    const { hasPermission } = usePermissions();
    const [selectedRows, setSelectedRows] = useState<string[]>([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const snackbarMessage = ''; // Replace with actual message
    const snackbarSeverity: 'success' | 'error' | 'info' | 'warning' = 'info';
    const [openAddDialog, setOpenAddDialog] = useState(false);
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [modalContent] = useState<'add' | 'edit'>('edit');

    const [searchTerm, setSearchTerm] = useState('');
    // const debouncedSearch = useDebounce(searchTerm, 400);
    
    // Pagination and sorting state
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [sortBy] = useState<'email'>('email');
    const [sortOrder] = useState<'asc' | 'desc'>('desc');


    // API hooks
    const { mutate: deleteNewsletterSubscribers } = useDeleteNewsletterSubscribers();
    const { mutate: toggleSubscribersStatus } = useToggleNewsletterSubscribersStatus();
    
    // Query parameters for API
    const queryParams = useMemo(() => ({
        page,
        limit: pageSize as any,
        search: searchTerm || undefined,
        sortBy: sortBy as any,
        sortOrder: sortOrder as any,
    }), [page, pageSize, searchTerm, sortBy, sortOrder]);

    const { data: newsletterData, isLoading } = useGetNewsletterSubscribers(queryParams);


    const filteredRows = useMemo(() => {
        const subscribers = newsletterData?.subscribers || [];
        
        return subscribers.map((row: any, index: number) => {
            if (!row) return { id: `empty-${index}`, sno: index + 1 };
            
            const rowWithSno = {
                ...row,
                id: row.id,
                sno: index + 1 + (Number(page - 1)) * Number(pageSize),
                email: row.email,
                subscribe: row.isActive ? 'subscribed' : 'unsubscribed',
            };
            
            return rowWithSno;
        });
    }, [newsletterData, page, pageSize]);


    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(e.target.value);
    };

    const handlePageChange = (newPage: number) => {
        setPage(newPage + 1);
    };

    const handlePageSizeChange = (newSize: number) => {
        setPageSize(newSize);
        setPage(1); // Reset to first page when changing page size
    };

    // const handleBlockClick = async () => {
    //     console.log('selectedRows', selectedRows);
    //     if (selectedRows.length === 0) {
    //         showMessage('Please select at least one choice to block', 'error');
    //     } else {
    //         const confirmed = window.confirm('Are you sure you want to block?');
    //         if (!confirmed) return;

    //         patchCMS({
    //             id: selectedRows,
    //             data: { status: 'blocked' },
    //         });
    //     }
    // };

    // const handleUnBlockClick = async () => {
    //     if (selectedRows.length === 0) {
    //         showMessage('Please select at least one choice to unblock', 'error');
    //     } else {
    //         const confirmed = window.confirm('Are you sure you want to unblock?');
    //         if (!confirmed) return;

    //         patchCMS({
    //             id: selectedRows,
    //             data: { status: 'unblocked' },
    //         });
    //     }
    // };

    // const handleDeleteClick = useCallback(() => {
    //     console.log('delete', selectedRows);
    //     if (selectedRows.length === 0) {
    //         showMessage('Please select at least one choice to delete', 'error');
    //     } else {
    //         const confirmed = window.confirm('Are you sure you want to delete?');
    //         if (!confirmed) return;

    //         // deleteCMS(selectedRows);
    //         deleteCMS(selectedRows, {
    //             onSuccess: () => {
    //                 setSelectedRows([]);
    //                 showMessage('CMS deleted successfully', 'success');

    //                 // Refetch data to update the table
    //                 // refetch();
    //             },
    //             onError: () => {
    //                 showMessage('Error deleting CMS', 'error');
    //                 // If there's an error, we might want to restore the selection
    //                 // setSelectedRows(selectedRows); // Uncomment if you want to restore selection on error
    //             },
    //         });
    //     }
    // }, [selectedRows]);

    const handleBlockClickButton = (id: string) => {
        const confirmed = window.confirm('Are you sure you want to subscribe?');
        if (!confirmed) return;
        toggleSubscribersStatus({ ids: [id], isActive: true });
    };
    const handleUnBlockClickButton = (id: string) => {
        const confirmed = window.confirm('Are you sure you want to unsubscribe?');
        if (!confirmed) return;
        toggleSubscribersStatus({ ids: [id], isActive: false });
    };

    const handleDeleteButton = useCallback(
        (id: string) => {
            console.log(id)
            const confirmed = window.confirm('Are you sure you want to delete?');
            if (!confirmed) return;

            deleteNewsletterSubscribers({ ids: [id] });
        },
        [deleteNewsletterSubscribers]
    );

    const handleAddSubAdmin = () => {
        setOpenAddDialog(true);
    };

    const handleCloseAddDialog = () => {
        setOpenAddDialog(false);
    };

    const handleCloseEditDialog = () => {
        setOpenEditDialog(false);
        setCMSAtom(null);
    };

    const handleBlockClick = async () => {
        console.log('selectedRows', selectedRows);
        if (selectedRows.length === 0) {
          showMessage('Please select at least one choice to block', 'error');
        } else {
          const confirmed = window.confirm('Are you sure you want to subscribe?');
          if (!confirmed) return;
          toggleSubscribersStatus({ ids: selectedRows, isActive: true });
        }
      };
    
      const handleUnBlockClick = async () => {
        if (selectedRows.length === 0) {
          showMessage('Please select at least one choice to unblock', 'error');
        } else {
          const confirmed = window.confirm('Are you sure you want to unsubscribe?');
          if (!confirmed) return;
          toggleSubscribersStatus({ ids: selectedRows, isActive: false });
        }
      };
    
      const handleDeleteClick = useCallback(() => {
        console.log('delete', selectedRows);
        if (selectedRows.length === 0) {
          showMessage('Please select at least one subscriber to delete', 'error');
          return;
        }
        
        const confirmed = window.confirm('Are you sure you want to delete?');
        if (!confirmed) return;
    
        // Clear selected rows immediately after confirmation
        setSelectedRows([]);
        
        deleteNewsletterSubscribers({ ids: selectedRows });
      }, [selectedRows, showMessage, deleteNewsletterSubscribers]);

    // Determine which bulk buttons to show based on selected rows' current status
    const { showBlock, showUnblock } = useMemo(() => {
        if (!selectedRows || selectedRows.length === 0) return { showBlock: false, showUnblock: false };
        const dataList = newsletterData?.subscribers || [];
        const idToIsActive = new Map<string, boolean>(
            dataList.map((item: any) => [String(item.id), Boolean(item.isActive)])
        );
        const statuses = selectedRows.map((id) => Boolean(idToIsActive.get(String(id))));
        const hasActive = statuses.some((s) => s === true);
        const hasInactive = statuses.some((s) => s === false);
        return {
            showBlock: hasInactive,   // show Subscribe when any selected is unsubscribed
            showUnblock: hasActive,   // show Unsubscribe when any selected is subscribed
        };
    }, [selectedRows, newsletterData]);

    const columns: GridColDef[] = [
        {
            field: 'sno',
            headerName: 'S.No',
            flex: 1, // small number
        },
        {
            field: 'email',
            headerName: 'Email',
            flex: 2, // moderately sized
        },
        // {
        //     field: 'subscribe',
        //     headerName: 'Subscribe/Unsubscribe',
        //     flex: 2, // moderately sized
        // },
        ...(hasPermission('newsLetter', 'Block') || hasPermission('newsLetter', 'Unblock') ? [{
            field: 'subscribe',
            headerName: 'Subscribe/Unsubscribe',
            disableColumnMenu: true,
            sortable: false,
            flex: 2,
            renderCell: (params: any) => {
                const isBlocked = String(params.value).toLowerCase() === 'unsubscribed';
                const id = params.row.id;
                const validId = typeof id === 'string' ? id : '';
                const action = isBlocked ? 'Unblock' : 'Block';

                if (!hasPermission('newsLetter', action)) {
                    return null;
                }

                return (
                    <IconButton
                        size="small"
                        sx={{ color: isBlocked ? '#f44336' : '#4caf50' }}
                        onClick={
                            () =>
                                isBlocked
                                    ? handleBlockClickButton(validId)
                                    : handleUnBlockClickButton(validId)
                        }
                    >
                        {isBlocked ? (
                            <BlockIcon fontSize="small" />
                        ) : (
                            <CheckCircleIcon fontSize="small" />
                        )}
                    </IconButton>
                );
            },
        }] : []),
        ...(hasPermission('newsLetter', 'Delete') ? [{
            field: 'delete',
            headerName: 'Delete',
            disableColumnMenu: true,
            sortable: false,
            flex: 1,
            renderCell: (params: any) => (
                <IconButton
                    color="error"
                    onClick={() => handleDeleteButton(params.row.id)}
                >
                    <DeleteIcon />
                </IconButton>
            ),
        }] : []),
    ];

    const handleRowSelection = (selectionModel: any) => {
    setSelectedRows(selectionModel);
  };


    return (
        <>
            <Typography variant="h5" fontWeight="bold" mb={2}>
                Newsletter Management
            </Typography>
            <Box
                sx={{
                    p: 2,
                    border: '1px solid #e0e0e0',
                    marginTop: '20px',
                    color: '#666',
                }}
            >
                {snackbarOpen && (
                    <Box sx={{ mb: 2 }}>
                        <Alert
                            severity={snackbarSeverity}
                            onClose={() => setSnackbarOpen(false)}
                        >
                            {snackbarMessage}
                        </Alert>
                    </Box>
                )}

                <Box
                    sx={{
                        // p: 2,
                        mb: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: 2, // Optional: adds spacing between wrapped items
                    }}
                >
                    {/* Search - Left */}
                    <Box
                        sx={{
                            width: 600,
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            background: '#fff',
                        }}
                    >
                        <TextField
                            fullWidth
                            placeholder="Search by Email Subscribe/Unsubscribe"
                            size="medium"
                            value={searchTerm}
                            onChange={handleSearchChange}
                            sx={{
                                '.MuiOutlinedInput-root': {
                                    height: 40,
                                    width: 600,
                                    border: 'none', // remove inner border
                                },
                                '& fieldset': {
                                    border: 'none', // remove Material-UI default border
                                },
                                '& .MuiInputBase-input': {
                                    paddingTop: '10px', // adjust this value to move the placeholder lower
                                },
                            }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon
                                            sx={{ fontSize: 20, color: '#aaa', mt: '4px' }}
                                        />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>

                    {/* Action Buttons + Add Button - Right */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            flexWrap: 'wrap',
                        }}
                    >
                        <PermissionActionButtons
                            module="newsLetter"
                            onBlock={showBlock ? handleBlockClick : undefined}
                            onUnblock={showUnblock ? handleUnBlockClick : undefined}
                            onDelete={selectedRows.length ? handleDeleteClick : undefined}
                            blockLabel={showBlock ? 'Subscribe' : undefined}
                            unblockLabel={showUnblock ? 'Unsubscribe' : undefined}
                        />
                        {hasPermission('newsLetter', 'Add') && (
                            <Button
                                variant="contained"
                                startIcon={<AddIcon />}
                                onClick={handleAddSubAdmin}
                                size="small"
                                sx={{
                                    textTransform: 'none',
                                    borderRadius: 2,
                                    bgcolor: COLORS.primary.main,
                                    boxShadow: 'none',
                                    '&:hover': {
                                        bgcolor: COLORS.primary.main,
                                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                    },
                                }}
                            >
                                Send Newsletter
                            </Button>
                        )}
                    </Box>
                </Box>

                <EditStoreOwnerModal
                    open={openAddDialog}
                    onClose={handleCloseAddDialog}
                    title="Add News Letter"
                >
                    <AddNewsLetter onCancel={handleCloseAddDialog} />
                </EditStoreOwnerModal>

                <EditStoreOwnerModal
                    open={openEditDialog}
                    onClose={handleCloseEditDialog}
                    title={modalContent === 'add' ? 'Add News Letter' : 'Edit News Letter'}
                >
                    <AddNewsLetter onCancel={handleCloseEditDialog} />
                </EditStoreOwnerModal>

                <CommonDataGrid
                    key={`datagrid-page-${page}-limit-${pageSize}`}
                    rows={filteredRows || []}
                    columns={columns}
                    pageSize={pageSize}
                    onPageChange={handlePageChange}
                    onPageSizeChange={handlePageSizeChange}
                    checkboxSelection
                    loading={isLoading}
                    page={page - 1}
                    rowCount={newsletterData?.pagination?.totalItems || 0}
                    onRowSelectionModelChange={handleRowSelection}
                    selectionModel={selectedRows}
                    components={{
                        NoRowsOverlay: () => (
                            <Box sx={{ p: 2, textAlign: 'center' }}>
                                <Typography>No newsletter subscribers found</Typography>
                            </Box>
                        )
                    }}
                />
            </Box>
        </>
    );
};

export default NewsLetter;
